// AdminPanel.jsx
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { FaUsers, FaMoneyBillWave, FaFileInvoiceDollar, FaBoxOpen, FaCog } from "react-icons/fa";
import AdminNavbar from "./AdminNavbar";
import axios from "axios";

const Container = styled.div`
  min-height: 100vh;
  background: linear-gradient(to bottom right, #f9f9f9, #e9eef2);
  font-family: "Inter", sans-serif;
  display: flex;
  flex-direction: column;
`;

const Content = styled.main`
  flex: 1;
  padding: 60px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Title = styled.h1`
  font-size: 32px;
  margin-bottom: 20px;
  color: #222;
`;

const Notification = styled.div`
  background-color: #fff3cd;
  color: #856404;
  padding: 15px 20px;
  border-radius: 8px;
  border: 1px solid #ffeeba;
  margin-bottom: 25px;
  width: 100%;
  max-width: 900px;
  font-weight: bold;
  font-size: 16px;
  text-align: center;
`;

const ButtonsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 20px;
  width: 100%;
  max-width: 900px;
`;

const DashboardButton = styled.button`
  background: #009fb7;
  color: white;
  border: none;
  border-radius: 12px;
  padding: 30px 20px;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;

  &:hover {
    background: #007f94;
    transform: translateY(-3px);
  }

  svg {
    font-size: 36px;
  }
`;

function AdminPanel() {
  const navigate = useNavigate();
  const adminUser = JSON.parse(localStorage.getItem("adminUser"));
  const role = adminUser?.userRole || "";

  const [newOrders, setNewOrders] = useState(0);
  const [newInvoices, setNewInvoices] = useState(0);

  const fetchNotifications = async () => {
    const lastOrderView =
      localStorage.getItem("lastOrderView") || localStorage.getItem("lastLogin");
    const lastInvoiceView =
      localStorage.getItem("lastInvoiceView") || localStorage.getItem("lastLogin");

    console.log("🔍 Last order view:", lastOrderView);
    console.log("🔍 Last invoice view:", lastInvoiceView);

    try {
      const [ordersRes, invoicesRes] = await Promise.all([
        axios.get("https://server229256.nazwa.pl/api/orders"),
        axios.get("https://server229256.nazwa.pl/api/generated-invoices"),
      ]);

      const newOrdersArr = ordersRes.data.filter(
        (order) => new Date(order.creationTime) > new Date(lastOrderView)
      );
      const newInvoicesArr = invoicesRes.data.filter(
        (invoice) => new Date(invoice.generatedAt) > new Date(lastInvoiceView)
      );

      console.log("📦 New orders:", newOrdersArr.length);
      console.log("🧾 New invoices:", newInvoicesArr.length);

      setNewOrders(newOrdersArr.length);
      setNewInvoices(newInvoicesArr.length);
    } catch (err) {
      console.error("❌ Error fetching notifications:", err);
    }
  };

  useEffect(() => {
    fetchNotifications();

    const handleFocus = () => {
      fetchNotifications();
    };

    window.addEventListener("focus", handleFocus);
    return () => {
      window.removeEventListener("focus", handleFocus);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const resetOrderNotifications = () => {
    console.log("🧹 Resetting ORDER notifications...");
    localStorage.setItem("lastOrderView", new Date().toISOString());
    setNewOrders(0);
  };

  const resetInvoiceNotifications = () => {
    console.log("🧹 Resetting INVOICE notifications...");
    localStorage.setItem("lastInvoiceView", new Date().toISOString());
    setNewInvoices(0);
  };

  const handleNavigateOrders = () => {
    resetOrderNotifications();
    navigate("/adminpanel/orders");
  };

  const handleNavigateInvoices = () => {
    resetInvoiceNotifications();
    navigate("/adminpanel/invoice");
  };

  return (
    <Container>
      <AdminNavbar />
      <Content>
        <Title>Witaj Administratorze!</Title>

        {(newOrders > 0 || newInvoices > 0) && (
          <Notification>
            🔔 Nowe powiadomienia:{" "}
            {newOrders > 0 && (
              <span style={{ color: "#28a745", fontWeight: "bold" }}>
                {newOrders} nowe zamówienia{" "}
              </span>
            )}
            {newInvoices > 0 && (
              <span style={{ color: "#007bff", fontWeight: "bold" }}>
                {newInvoices} nowe faktury
              </span>
            )}
          </Notification>
        )}

        <ButtonsGrid>
          {role === "SUPERADMIN" && (
            <>
              <DashboardButton onClick={() => navigate("/adminpanel/admin-users")}>
                <FaUsers />
                Użytkownicy
              </DashboardButton>

              <DashboardButton onClick={handleNavigateOrders}>
                <FaBoxOpen />
                Zamówienia
              </DashboardButton>

              <DashboardButton onClick={handleNavigateInvoices}>
                <FaFileInvoiceDollar />
                Faktury
              </DashboardButton>

    
              <DashboardButton onClick={() => navigate("/adminpanel/settings")}>
                <FaCog />
                Ustawienia
              </DashboardButton>
            </>
          )}

          {role === "INFLUENCER" && (
            <DashboardButton onClick={() => navigate("/adminpanel/revenue")}>
              <FaMoneyBillWave />
              Przychody
            </DashboardButton>
          )}
        </ButtonsGrid>
      </Content>
    </Container>
  );
}

export default AdminPanel;
